<template>
  <div class="page-stats">
    <landing-header />

    <main>
      <section class="hero-stats">
        <div class="max-w-7xl mx-auto px-4 flex flex-col lg:flex-row items-center gap-16">
          <div class="lg:w-1/2">
            <span class="badge-stats">Business Intelligence</span>
            <h1 class="text-4xl md:text-6xl font-black text-gray-900 mb-6 leading-tight">
              Pilotez votre activité <br />
              <span class="gradient-text">par la donnée</span>
            </h1>
            <p class="text-xl text-gray-600 mb-8 leading-relaxed">
              Transformez vos interventions terrain en indicateurs de performance. Prenez des décisions éclairées basées sur des faits réels, pas sur des suppositions.
            </p>
            <div class="flex flex-wrap gap-4">
              <a href="/contact"><button class="btn-primary">Demander une démonstration</button></a>
              <a href="/fonctionnalites" class="btn-outline-large">Autres fonctionnalités</a>
            </div>
          </div>
          
          <div class="lg:w-1/2 w-full">
            <div class="stats-dashboard shadow-2xl">
              <div class="dash-grid">
                <div class="dash-item main">
                  <span class="label">Volume Interventions</span>
                  <span class="value">412</span>
                  <span class="trend up">+12% ce mois</span>
                </div>
                <div class="dash-item">
                  <span class="label">Temps Trajet</span>
                  <span class="value">18%</span>
                  <div class="mini-bar"><div class="fill" style="width: 18%"></div></div>
                </div>
                <div class="dash-item">
                  <span class="label">CERFA Générés</span>
                  <span class="value">89</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-gray-900 text-white">
        <div class="max-w-7xl mx-auto px-4">
          <div class="text-center mb-20">
            <h2 class="text-3xl font-bold mb-4">Une vision à 360° de votre performance</h2>
            <p class="text-gray-400">Des tableaux de bord conçus pour les réalités des métiers du CVC.</p>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div class="stat-card">
              <i class="fa-solid fa-hourglass-half"></i>
              <h3>Temps & Déplacements</h3>
              <p>Analysez le ratio temps d'intervention vs temps de route pour optimiser vos tournées.</p>
            </div>
            <div class="stat-card">
              <i class="fa-solid fa-users-gear"></i>
              <h3>Performance Équipes</h3>
              <p>Suivez la charge de travail et la productivité par technicien en temps réel.</p>
            </div>
            <div class="stat-card">
              <i class="fa-solid fa-boxes-stacked"></i>
              <h3>Matériel & Fluides</h3>
              <p>Visualisez la consommation de pièces et le flux des fluides frigorigènes.</p>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-white">
        <div class="max-w-7xl mx-auto px-4">
          <div class="flex flex-col lg:flex-row gap-20 items-center">
            <div class="lg:w-1/2 order-2 lg:order-1">
               <div class="conformity-visual shadow-lg">
                  <div class="c-title">Niveau de Conformité</div>
                  <div class="c-radial">100%</div>
                  <p class="text-xs text-center text-gray-500 mt-4">Tous documents réglementaires à jour</p>
               </div>
            </div>
            <div class="lg:w-1/2 order-1 lg:order-2">
              <h2 class="text-3xl font-bold text-gray-900 mb-6">La conformité sous contrôle</h2>
              <p class="text-gray-600 mb-8 text-lg">Plus besoin de compiler des fichiers Excel pendant des heures. Termoflow consolide automatiquement vos données réglementaires (CERFA, fluides, étalonnages) pour vos reportings et audits.</p>
              <ul class="check-list-stats">
                <li><i class="fa-solid fa-check"></i> Consolidation automatique des données</li>
                <li><i class="fa-solid fa-check"></i> Historique illimité pour vos analyses</li>
                <li><i class="fa-solid fa-check"></i> Exportation prête pour le pilotage financier</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-gray-50">
        <div class="max-w-7xl mx-auto px-4">
          <h2 class="text-center text-3xl font-bold mb-16">Prenez une longueur d'avance</h2>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div class="benefit-box-stats">
              <i class="fa-solid fa-eye"></i>
              <p>Visibilité totale sur l'activité</p>
            </div>
            <div class="benefit-box-stats">
              <i class="fa-solid fa-bullseye"></i>
              <p>Anticipation des besoins stocks</p>
            </div>
            <div class="benefit-box-stats">
              <i class="fa-solid fa-chart-line"></i>
              <p>Maîtrise des coûts réels</p>
            </div>
            <div class="benefit-box-stats">
              <i class="fa-solid fa-shield"></i>
              <p>Décisions 100% fiables</p>
            </div>
          </div>
        </div>
      </section>

      <section class="py-20 text-center">
        <div class="max-w-3xl mx-auto px-4">
          <h2 class="text-4xl font-black text-gray-900 mb-8">Ne pilotez plus à l'aveugle</h2>
          <div class="flex flex-col sm:flex-row justify-center gap-4">
             <a href="/contact"><button class="btn-primary">Demander une démonstration</button></a>
             <a href="/fonctionnalites" class="btn-outline-large">Autres fonctionnalités</a>
          </div>
        </div>
      </section>

      <landing-roi />
      <landing-avis />
    </main>

    <landing-footer />
  </div>
</template>

<script>
import LandingHeader from './LandingHeader.vue'
import LandingFooter from './LandingFooter.vue'
import LandingAvis from './LandingAvis.vue'
import LandingROI from './LandingROI.vue'

export default {
  name: 'StatsPage',
  components: {
    LandingHeader,
    LandingFooter,
    LandingAvis,
    'landing-roi': LandingROI
  }
}
</script>

<style scoped>
/* --- UTILS --- */
.gradient-text {
  background: linear-gradient(to right, #f97316, #ef4444);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* --- HERO --- */
.hero-stats {
  padding: 10rem 0 6rem;
  background: radial-gradient(circle at top right, #fff7ed, transparent 35%);
}

.badge-stats {
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: #ecfdf5;
  color: #059669;
  font-weight: 800;
  font-size: 0.75rem;
  border-radius: 9999px;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
}

/* --- DASHBOARD UI --- */
.stats-dashboard {
  background: white;
  border-radius: 2rem;
  padding: 2rem;
  border: 1px solid #e5e7eb;
}
.dash-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; }
.dash-item { padding: 1.5rem; background: #f9fafb; border-radius: 1rem; display: flex; flex-direction: column; }
.dash-item.main { grid-column: span 2; }
.dash-item .label { font-size: 0.75rem; font-weight: 800; color: #9ca3af; text-transform: uppercase; }
.dash-item .value { font-size: 2.5rem; font-weight: 900; color: #1f2937; margin: 0.5rem 0; }
.trend.up { color: #16a34a; font-size: 0.8rem; font-weight: 700; }
.mini-bar { width: 100%; height: 8px; background: #e5e7eb; border-radius: 4px; margin-top: 1rem; }
.mini-bar .fill { height: 100%; background: #f97316; border-radius: 4px; }

/* --- CARDS DARK --- */
.stat-card { background: #1f2937; padding: 2.5rem; border-radius: 1.5rem; border: 1px solid #374151; transition: transform 0.3s; }
.stat-card:hover { transform: translateY(-10px); }
.stat-card i { font-size: 2.5rem; color: #f97316; margin-bottom: 1.5rem; }
.stat-card h3 { font-size: 1.25rem; font-weight: 800; margin-bottom: 1rem; }
.stat-card p { color: #9ca3af; font-size: 0.9rem; line-height: 1.6; }

/* --- CONFORMITY VISUAL --- */
.conformity-visual { width: 280px; height: 280px; background: white; border-radius: 50%; margin: 0 auto; display: flex; flex-direction: column; align-items: center; justify-content: center; border: 15px solid #f0fdf4; outline: 1px solid #dcfce7; }
.c-title { font-weight: 800; font-size: 0.7rem; color: #9ca3af; text-transform: uppercase; margin-bottom: 1rem; }
.c-radial { font-size: 4rem; font-weight: 900; color: #16a34a; }

/* --- CHECK LIST --- */
.check-list-stats { list-style: none; padding: 0; }
.check-list-stats li { display: flex; align-items: center; gap: 1rem; font-weight: 700; color: #4b5563; margin-bottom: 1rem; }
.check-list-stats li i { color: #16a34a; }

/* --- BENEFIT BOX --- */
.benefit-box-stats { background: white; padding: 2rem; border-radius: 1.25rem; text-align: center; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05); }
.benefit-box-stats i { font-size: 1.5rem; color: #f97316; margin-bottom: 1rem; display: block; }
.benefit-box-stats p { font-weight: 800; color: #1f2937; font-size: 0.9rem; }

/* --- BUTTONS --- */
.btn-primary { background: #f97316; color: white; padding: 1.2rem 3rem; border-radius: 9999px; font-weight: 800; border: none; font-size: 1.1rem; }
.btn-outline-large { border: 2px solid #e5e7eb; padding: 1.2rem 3rem; border-radius: 9999px; font-weight: 800; color: #1f2937; text-decoration: none; display: inline-block; }

@media (max-width: 1024px) {
  .hero-stats { text-align: center; padding-top: 8rem; }
  .hero-stats .flex { flex-direction: column; }
  .stats-dashboard { margin-top: 4rem; }
}
</style>